// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { stopSubmit } from 'redux-form'
import { fromJS } from 'immutable'
import { loadingToggler } from 'redux/modules/loading'
import scrubPathSummary from 'components/PathSummary/prepData/scrubPathSummary'
import { copyPathsIntoProject } from 'helpers/api'
import { formatErrorData } from 'helpers/reduxFormFunctions'

import {
  fetchAndSetProjectCompanies,
  filterAndSortPathIds,
  projectSummaryModalOpen,
  updateModalMessage,
  updatePaths,
} from 'redux/modules/projectSummary'

// takes an array of path ids and tells the API to import them
// into the current project

// NOTE - importTypeForm will either be PATH_DATABASE_IMPORT or PROJECT_PATH_IMPORT
// this allows us to populate the <SearchAndSelect /> form which is
// associated with these two import scenarios.

// because we want to populate the form outside of the form's submission handler, we need some other
// mechanism to tell redux-form which form to feed the errors.

const handlePathsImport = (pathIds, importTypeForm) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { projectSummary } = getState()

      const storedPaths = projectSummary.get('paths')
      const projectId = projectSummary.get('projectId')
      const unitType = projectSummary.get('unitType')
      let prevPathCount = projectSummary.get('paths').size

      try {
        const { entity } = await copyPathsIntoProject(projectId, pathIds)

        // omits the paths which are already in redux state
        const newlyCreatedPaths = entity.paths.splice(prevPathCount, entity.paths.length)

        // NOTE - we determine how many paths were added from the response
        // and not the original pathIds array because any duplicate ids or
        // soft deleted pathIds will be ignored from the request
        const newlyCreatedPathCount = newlyCreatedPaths.length

        // creates an immutable List of all path summaries for this project
        // after the paths were imported.
        const newPathSet = newlyCreatedPaths.reduce((a, path) => {
          const scrubbedPathSummary = scrubPathSummary(path, prevPathCount, unitType)
          ++prevPathCount
          return a.push(fromJS(scrubbedPathSummary))
        }, storedPaths)

        // then persist those new values in redux state
        dispatch(updatePaths(newPathSet))
        // triggers an update to the visible paths in project summary.
        dispatch(filterAndSortPathIds())

        // update the project's companies list after the transaction
        dispatch(fetchAndSetProjectCompanies(projectId))

        dispatch(projectSummaryModalOpen('import-success'))
        dispatch(updateModalMessage(`Successfully imported ${newlyCreatedPathCount} path${newlyCreatedPathCount > 1 ? 's' : ''}`))
      } catch (err) {
        console.warn(err)

        // trigger a submission error to be displayed in the UI
        // this thunk is not a submit handler for a redux-form however it DOES allow us to map
        // import errors into the path import form
        const errorData = formatErrorData(err)
        dispatch(stopSubmit(importTypeForm, errorData))
      }
    })
  )
)

export default handlePathsImport
